import PackageSubscriptionReports from "../Pages/Admin/PackageSubscriptionReports/PackageSubscriptionReports";
import ResidentReports from "../Pages/Admin/ResidentReports/ResidentReports";
import PrivateRoute from "../Components/Common/PrivateRoute/PrivateRoute";
import FutureBookings from "../Pages/Admin/FutureBookings/FutureBookings";
import MobileHeader from "../Components/Admin/MobileHeader/MobileHeader";
import PublicRoute from "../Components/Common/PublicRoute/PublicRoute";
import CouponsReport from "../Pages/Admin/CouponsReport/CouponsReport";
import ProfitReport from "../Pages/Admin/ProfitReport/ProfitReport";
import PastBookings from "../Pages/Admin/PastBookings/PastBookings";
import MemberReport from "../Pages/Admin/MemberReport/MemberReport";
import MemberDetail from "../Pages/Admin/MemberDetail/MemberDetail";
import EditBuilding from "../Pages/Admin/EditBuilding/EditBuilding";
import DoorHistory from "../Pages/Admin/DoorHistory/DoorHistory";
import AddBuilding from "../Pages/Admin/AddBuilding/AddBuilding";
import EditMember from "../Pages/Admin/EditMember/EditMember";
import EditCoupon from "../Pages/Admin/EditCoupon/EditCoupon";
import AddMember from "../Pages/Admin/AddMembers/AddMember";
import EditGroup from "../Pages/Admin/EditGroup/EditGroup";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import Buildings from "../Pages/Admin/Buildings/Buildings";
import AddCoupon from "../Pages/Admin/AddCoupon/AddCoupon";
import Sidebar from "../Components/Admin/Sidebar/Sidebar";
import EditUser from "../Pages/Admin/EditUser/EditUser";
import AddGroup from "../Pages/Admin/AddGroup/AddGroup";
import Header from "../Components/Admin/Header/Header";
import Members from "../Pages/Admin/Members/Members";
import Coupons from "../Pages/Admin/Coupons/Coupons";
import AddUser from "../Pages/Admin/AddUser/AddUser";
import { Outlet, RouteObject } from "react-router";
import Groups from "../Pages/Admin/Groups/Groups";
import Users from "../Pages/Admin/Users/Users";
import Login from "../Pages/Admin/Login/Login";
import styles from "./AdminRoutes.module.scss";
import { RootState } from "../Redux/store";
import { useSelector } from "react-redux";

const AdminLayout = () => {
  const { admin } = useSelector((state: RootState) => state.auth);
  const isDoorAdminRole = admin?.role === "DoorLogAdmin";

  return (
    <div
      className={
        isDoorAdminRole
          ? styles.doorUserLayoutContainer
          : styles.userLayoutContainer
      }
    >
      <div className={styles.userLayoutHeader}>
        <div className={styles.desktopHeader}>
          <Header />
        </div>
        <div className={styles.mobileHeader}>
          <MobileHeader />
        </div>
      </div>
      <div className={styles.userLayoutBody}>
        {
          <div className={styles.sidebar}>
            <Sidebar />
          </div>
        }
        <div className={styles.userLayoutContent}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const adminRoutes: RouteObject[] = [
  {
    path: "/admin/login",
    element: (
      <PublicRoute isAdmin={true} isAuthPage={true}>
        <Login />
      </PublicRoute>
    ),
  },
  {
    element: <AdminLayout />,
    children: [
      {
        path: "/admin",
        element: (
          <PrivateRoute isAdmin={true}>
            <Dashboard />
          </PrivateRoute>
        ),
      },

      {
        path: "/admin/buildings",
        element: (
          <PrivateRoute isAdmin={true}>
            <Buildings />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/groups",
        element: (
          <PrivateRoute isAdmin={true}>
            <Groups />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/groups/add",
        element: (
          <PrivateRoute isAdmin={true}>
            <AddGroup />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/groups/edit/:id",
        element: (
          <PrivateRoute isAdmin={true}>
            <EditGroup />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/users",
        element: (
          <PrivateRoute isAdmin={true}>
            <Users />
          </PrivateRoute>
        ),
      },

      {
        path: "/admin/members",
        element: (
          <PrivateRoute isAdmin={true}>
            <Members />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/members/add",
        element: (
          <PrivateRoute isAdmin={true}>
            <AddMember />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/members/detail/:id",
        element: (
          <PrivateRoute isAdmin={true}>
            <MemberDetail />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/members/edit/:id",
        element: (
          <PrivateRoute isAdmin={true}>
            <EditMember />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/coupons",
        element: (
          <PrivateRoute isAdmin={true}>
            <Coupons />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/coupons/add",
        element: (
          <PrivateRoute isAdmin={true}>
            <AddCoupon />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/coupons/edit/:id",
        element: (
          <PrivateRoute isAdmin={true}>
            <EditCoupon />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/users/add",
        element: (
          <PrivateRoute isAdmin={true}>
            <AddUser />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/users/edit/:id",
        element: (
          <PrivateRoute isAdmin={true}>
            <EditUser />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/buildings/add",
        element: (
          <PrivateRoute isAdmin={true}>
            <AddBuilding />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/buildings/edit/:id",
        element: (
          <PrivateRoute isAdmin={true}>
            <EditBuilding />
          </PrivateRoute>
        ),
      },

      {
        path: "/admin/reports/members",
        element: (
          <PrivateRoute isAdmin={true}>
            <MemberReport />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/reports/residents",
        element: (
          <PrivateRoute isAdmin={true}>
            <ResidentReports />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/reports/package",
        element: (
          <PrivateRoute isAdmin={true}>
            <PackageSubscriptionReports />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/reports/futurebookings",
        element: (
          <PrivateRoute isAdmin={true}>
            <FutureBookings />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/reports/coupons",
        element: (
          <PrivateRoute isAdmin={true}>
            <CouponsReport />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/reports/profit",
        element: (
          <PrivateRoute isAdmin={true}>
            <ProfitReport />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/reports/pastbookings",
        element: (
          <PrivateRoute isAdmin={true}>
            <PastBookings />
          </PrivateRoute>
        ),
      },
      {
        path: "/admin/reports/doorhistory",
        element: (
          <PrivateRoute isAdmin={true} isDoorAdmin={true}>
            <DoorHistory />
          </PrivateRoute>
        ),
      },
    ],
  },
];

export default adminRoutes;
